import ReduxStore from '../../../ReduxStore';
import cloneDeep from 'lodash/cloneDeep';
import {resizePropertyImages} from 'lib/ReportUtil';
import {encodedUriWithoutResize} from 'api/reports/util/UriUtils';
import {makeComparableSection} from 'api/reports/cma/ComparableSectionFactory';
import Formatter from 'lib/Formatter';
import States from '../../../constants/states';
import VicMetroCouncils from '../../../constants/vicMetroCouncils';
import {MIN_SOI_COMPARABLES} from 'constants/soi';

export const getSOIReportPayload = () => {
  const {
    featureFlags,
    indicativeSellingPrice,
    sellersReservePrice,
    propertyDetail,
    userDetails,
    comparableSales,
    propertyNotes,
    userSettings,
    fewerComparablesReason
  } = ReduxStore.getState();

  let targetProperty = cloneDeep(propertyDetail);
  targetProperty = resizePropertyImages(targetProperty);
  targetProperty.imageUri = encodedUriWithoutResize(targetProperty.imageUri);

  const selectedComparableSales = makeComparableSection('sales', comparableSales, featureFlags, userSettings, propertyNotes, featureFlags.enableUndisclosedPriceInSOIReport);
  const sellingPrice = indicativeSellingPrice.sellingPriceType === 'price-range'
    ? {
      price: Formatter.currency(indicativeSellingPrice.priceRange.min),
      toPrice: Formatter.currency(indicativeSellingPrice.priceRange.max)
    }
    : {price: Formatter.currency(indicativeSellingPrice.singlePrice)};

  const stateIsVic = targetProperty.addressState?.toUpperCase() === States.VIC;
  const isMetroProperty = VicMetroCouncils
      .includes(targetProperty?.councilArea?.toUpperCase());

  targetProperty.metroProperty = stateIsVic && isMetroProperty;

  const reservePrice = sellersReservePrice?.reservePrice;
  const includeReservePrice = !!featureFlags.propertyPriceStatement && !!reservePrice;

  const includeFewerComparablesReason = !!featureFlags.propertyPriceStatement &&
    (comparableSales?.selected?.length ?? 0) < MIN_SOI_COMPARABLES &&
    !!fewerComparablesReason?.declared;

  return {
    userDetails,
    comparableSales: selectedComparableSales,
    propertyDetail: targetProperty,
    indicativeSellingPrice: sellingPrice,
    ...(includeReservePrice
      ? {sellersReservePrice: {price: Formatter.currency(reservePrice)}}
      : {}),
    ...(includeFewerComparablesReason
      ? {
        fewerComparablesReason: {
          declared: true,
          explanation: fewerComparablesReason.explanation || '',
        }
      }
      : {}),
    consumerAffairsLayout: true,
  };
};
